import { Link } from 'react-router-dom';

interface LogoProps {
    className?: string; // Additional classes for the container
    imageSize?: string; // size classes for the image, e.g., 'w-12 h-12'
    textSize?: string; // size classes for the text, e.g., 'text-2xl'
    showSubheading?: boolean; // toggle subheading
    subheadingSize?: string; // size for subheading
    subheadingText?: string; // custom subheading text
    isLink?: boolean; // if true (default), wraps in Link to home
    showText?: boolean; // if true (default), shows BhriguGPT text
    showOnlineIndicator?: boolean; // if true, shows a blinking green dot next to subheading
    vertical?: boolean; // if true, stack logo image and text vertically (for mobile footer)
}

const Logo = ({
    className = "",
    imageSize = "w-12 h-12",
    textSize = "text-2xl",
    showSubheading = false,
    subheadingSize = "text-[10px]",
    subheadingText = "AI Astrologer",
    isLink = true,
    showText = true,
    showOnlineIndicator = false,
    vertical = false
}: LogoProps) => {

    const layoutClass = vertical
        ? "flex flex-col items-center gap-2 text-center"
        : "flex items-center gap-2 md:gap-3";

    const Content = () => (
        <>
            <div className="relative shrink-0">
                <div className="absolute inset-0 bg-purple-600 blur-lg opacity-20 group-hover:opacity-40 transition-opacity" />
                <img
                    src="/bhrigoo_rishi.webp"
                    alt="Bhrigu Rishi"
                    className={`${imageSize} object-contain relative z-10 drop-shadow-[0_0_10px_rgba(147,51,234,0.5)]`}
                />
            </div>
            {showText && (
                <div className={`flex flex-col ${vertical ? 'items-center' : 'justify-center'} overflow-visible`}>
                    <span
                        className={`${textSize} font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-purple-100 via-purple-300 to-purple-500 tracking-wide font-serif leading-[1.3]`}
                    >
                        BhriguGPT
                    </span>
                    {showSubheading && (
                        <div className={`flex items-center gap-1.5 mt-1 ${vertical ? 'justify-center' : ''}`}>
                            {showOnlineIndicator && (
                                <div className="relative flex h-2 w-2">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75"></span>
                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-purple-500"></span>
                                </div>
                            )}
                            <span className={`${subheadingSize} text-purple-300/60 uppercase tracking-[0.2em] font-sans font-bold whitespace-nowrap`}>
                                {subheadingText}
                            </span>
                        </div>
                    )}
                </div>
            )}

        </>
    );

    if (isLink) {
        return (
            <Link to="/" className={`${layoutClass} group ${className}`}>
                <Content />
            </Link>
        );
    }

    return (
        <div className={`${layoutClass} group cursor-default ${className}`}>
            <Content />
        </div>
    );
};

export default Logo;
